import { api, ApiError } from "@/api/api";
import { CreateStoryConfigRevision, StoryConfigRevision } from "@/api/story-configs-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Variables = {
  configId: string;
  data: CreateStoryConfigRevision;
};

export function useCreateStoryConfigRevision() {
  const queryClient = useQueryClient();
  return useMutation<StoryConfigRevision, ApiError, Variables>({
    mutationKey: ["POST", "storyConfigs", ":configId", "revisions"],
    mutationFn: (variables) =>
      api.storyConfigs.configId.revisions.post(variables.configId, variables.data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["GET", "storyConfigs"] });
      queryClient.invalidateQueries({ queryKey: ["GET", "storyConfigs", variables.configId] });
    }
  });
}
